var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33594C4.32416 1.33594 1.3335 4.3266 1.3335 8.0026C1.3335 11.6786 4.32416 14.6693 8.00016 14.6693C11.6762 14.6693 14.6668 11.6786 14.6668 8.0026C14.6668 4.3266 11.6762 1.33594 8.00016 1.33594ZM8.00016 13.3359C5.0595 13.3359 2.66683 10.9433 2.66683 8.0026C2.66683 5.06194 5.0595 2.66927 8.00016 2.66927C10.9408 2.66927 13.3335 5.06194 13.3335 8.0026C13.3335 10.9433 10.9408 13.3359 8.00016 13.3359Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66541 9.06058L5.13274 7.53058L4.19141 8.47458L6.66674 10.9446L11.1374 6.47392L10.1947 5.53125L6.66541 9.06058Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCheckCircle);
export default __webpack_public_path__ + "static/media/bx-check-circle.10d467dae85d5c4c363f4051f3bfc415.svg";
export { ForwardRef as ReactComponent };